module.exports = {
      id: "icon-overview-bookings-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-overview-bookings",
      toString: function () {
        return this.url;
      }
    }